require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-partners-with-consulate-of-colombia.json") })
        }
      }, "path---es-articles-partners-with-consulate-of-colombia");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-partners-with-consulate-of-colombia!./.cache/json/es-articles-partners-with-consulate-of-colombia.json
// module id = 2230
// module chunks = 231608221292675